import { Html } from '@react-three/drei'
import { StyleSheet, css } from 'aphrodite'
import React, { useEffect, useState, useRef } from 'react'
import { CloseIcon, TidBits } from '../assets/svgs/Buttons'
import { popupColorThemes as colorThemes } from '../../constants'
import ReactGA from 'react-ga'
import { usePage } from '../../stores'
import { GodrejLogo } from '../assets/svgs/GodrejLogo'
import VimeoPlayer from 'react-player/vimeo'
import { sendEvent } from '../GA/google-analytics'

const Logo = (props) => (
  <svg
    {...props}
    width={'100%'}
    viewBox="0 0 179 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.7283 0.773628C28.9599 0.995533 26.5199 1.6181 24.8439 2.27765C20.8265 3.85564 17.4006 5.95757 13.9685 8.96562C10.6597 11.8565 8.45378 15.0433 8.0163 17.5644C7.92387 18.1007 7.97316 19.0191 8.12104 19.4013C8.36135 20.0239 8.97136 20.6218 9.6245 20.8684C10.3084 21.1272 10.7582 21.1827 11.8119 21.1519C13.2784 21.0964 14.0055 20.9115 15.5397 20.178C16.5071 19.7157 16.581 19.7157 16.3407 20.178C16.1128 20.628 15.4535 21.2567 14.7818 21.6697C8.68792 25.3989 6.30335 27.0262 4.35625 28.7768C2.64946 30.324 1.71289 31.6184 1.39248 32.882C1.25692 33.4306 1.29389 34.2936 1.47874 34.6449C1.79915 35.2675 2.46461 35.5757 3.5922 35.6374C4.76908 35.699 5.72415 35.4709 7.12901 34.7929C10.8075 33.0053 15.3179 28.2775 19.4955 21.8114C19.9453 21.1211 20.2103 20.8684 21.2701 20.1287C23.9319 18.2733 24.4988 17.9343 24.6282 18.1439C24.6467 18.1747 24.5912 18.4705 24.505 18.7972C24.2154 19.9191 24.3201 20.4739 24.9117 21.0101C25.3799 21.4293 25.8482 21.5649 26.717 21.5217C28.011 21.4601 29.0831 21.0348 30.4325 20.0424C30.8454 19.7342 32.2194 18.3904 33.5935 16.9419C34.6841 15.8015 35.2879 15.3762 35.8425 15.3762C36.0027 15.3762 36.1198 15.407 36.1198 15.444C36.1198 15.481 36.0643 15.7214 36.0027 15.9803C35.6453 17.3918 35.5159 18.8096 35.6884 19.4445C35.8733 20.1287 36.2861 20.6958 36.8345 21.0163C37.5061 21.4108 38.8864 21.5402 39.8229 21.2998C42.0103 20.7389 44.1731 18.4397 45.7751 14.9755C46.2866 13.8722 46.7733 12.2387 46.7795 11.6408C46.7795 11.2401 46.8288 11.2278 47.7962 11.3264C48.7204 11.4189 48.8806 11.4867 49.0778 11.8689C49.4968 12.6579 48.4616 14.7351 45.159 19.765C44.7585 20.3691 44.438 20.9115 44.438 20.9731C44.438 21.2259 44.512 21.232 46.5145 21.232H48.4431L48.6526 21.0286C48.7697 20.9238 49.4413 19.9314 50.1561 18.8281C52.0169 15.9556 52.0169 15.9556 52.134 16.2515C52.4298 17.022 52.6208 17.2254 53.1692 17.3857C53.5943 17.509 54.42 17.4781 54.8698 17.3179C55.03 17.2562 55.1779 17.2254 55.1964 17.2439C55.2148 17.2624 55.1594 17.5336 55.0731 17.848C54.9499 18.298 54.9129 18.5692 54.9129 19.0746C54.9129 21.0841 55.9111 21.9594 57.7473 21.571C59.3986 21.2259 61.1116 20.2458 63.3853 18.3473C63.7919 18.0082 64.137 17.737 64.1431 17.7494C64.1924 17.7987 63.5516 18.9513 63.034 19.7342C61.8079 21.608 59.83 24.1045 56.2069 28.3823C53.2431 31.8835 52.6023 32.7341 52.3127 33.5416C52.0724 34.232 52.3189 35.0333 52.9042 35.4771C53.9147 36.2414 55.0485 35.8284 56.7799 34.0717C59.0905 31.717 61.0561 28.6535 66.8974 18.3041C68.3701 15.6967 69.6024 13.9585 71.075 12.4236C72.2088 11.2463 72.6586 10.5683 72.6586 10.0628C72.6586 9.51422 72.2642 9.0889 71.7528 9.0889C71.112 9.0889 69.7441 9.92104 68.4193 11.1107C67.9695 11.5175 67.5321 11.9737 66.0717 13.5578C63.2435 16.6337 61.66 17.774 60.2181 17.7802C59.565 17.7802 59.3617 17.6384 59.1953 17.0528C59.1398 16.8679 59.2569 16.535 59.4356 16.3686C59.5157 16.2946 59.83 16.1405 60.1442 16.0234C61.3704 15.5673 62.6705 14.7413 63.7858 13.7181C65.7082 11.9552 66.3552 10.0875 65.3139 9.31697C64.8394 8.95945 63.3914 9.21834 62.0297 9.90255C60.6864 10.5806 58.9612 12.023 57.735 13.5085C57.3591 13.9585 56.8908 14.3283 56.6998 14.3283C56.1699 14.3283 55.9666 12.5038 56.3671 11.3326C56.4164 11.1847 56.5827 10.8025 56.7306 10.4758C57.0695 9.74845 57.0942 9.47107 56.8292 9.20601C56.6813 9.05808 56.5951 9.02726 56.3609 9.02726C55.8372 9.02726 55.3196 9.36012 54.001 10.5621C53.5882 10.9381 53.2246 11.2463 53.1877 11.2463C53.1568 11.2463 53.0151 11.0059 52.8796 10.71C52.4051 9.71763 52.1278 9.44641 51.3576 9.22451C51.0495 9.13205 50.7045 9.11972 48.9053 9.13821C47.753 9.14437 46.7179 9.13821 46.607 9.11972C46.416 9.08274 46.379 9.03959 46.1818 8.6081C45.5841 7.28284 45.0481 6.35824 44.321 5.39048C42.7497 3.29472 40.8027 2.00644 38.6892 1.66125C36.4771 1.30373 35.0291 1.95712 34.7087 3.46731C34.4315 4.79257 35.0291 6.41988 36.2368 7.60953C37.044 8.41086 38.4181 9.23067 39.749 9.7053C40.0571 9.81625 40.3097 9.92721 40.3097 9.95803C40.3097 10.069 39.5149 11.0059 38.9726 11.536C38.6584 11.8504 38.1531 12.2634 37.8574 12.4606C37.3459 12.8058 36.5449 13.1387 36.4217 13.0647C36.3416 13.0092 36.3539 12.8551 36.4956 12.251C36.6004 11.8196 36.6189 11.573 36.6004 11.0244C36.5757 10.4018 36.5572 10.297 36.3786 9.93337C36.2676 9.71147 36.089 9.45258 35.9781 9.36012C35.4666 8.92247 34.7395 8.76837 33.8399 8.89781C32.0222 9.16903 30.0074 10.5436 26.3227 14.0201C25.7312 14.581 25.115 15.142 24.9609 15.2714C24.6221 15.5426 23.9011 15.931 23.7286 15.931C23.5807 15.931 23.4821 16.0789 24.8993 14.1434C26.3966 12.0908 27.1668 11.0799 27.555 10.6299C28.2451 9.83475 28.3252 9.60051 27.9863 9.3108C27.6474 9.02726 27.0313 9.02109 26.2303 9.29231C25.0965 9.68064 24.887 9.84091 22.6257 12.0723C19.1505 15.4995 16.9076 17.3302 15.3241 18.0144C14.406 18.4151 13.8268 18.3349 13.568 17.7617C13.3277 17.2377 13.4632 16.6398 14.1225 15.2899C16.2113 11.0121 20.2657 7.22736 24.6282 5.48294C26.6616 4.66929 28.0603 4.45971 29.9889 4.67546C30.5003 4.7371 30.9748 4.79874 31.0487 4.81723C31.1473 4.83572 31.2335 4.79874 31.3506 4.66929C31.6032 4.40424 33.4148 1.13114 33.3963 0.983204C33.384 0.896908 33.3039 0.841434 33.1005 0.785957C32.7801 0.705826 31.3568 0.699661 30.7283 0.773628ZM40.205 4.02823C41.6961 4.55834 43.1071 6.19797 44.0314 8.4725C44.2101 8.91014 44.2286 9.07657 44.1115 9.12588C43.8404 9.22451 42.1952 8.70673 41.1292 8.18895C39.2746 7.28284 38.0977 6.14249 37.9375 5.10694C37.8635 4.61998 38.1038 4.10837 38.4859 3.93577C38.7631 3.80633 39.7428 3.8618 40.205 4.02823ZM43.902 11.0059C44.5983 11.1785 44.6845 11.2463 44.6845 11.5915C44.6845 11.9059 44.4011 12.9352 44.1238 13.6318C43.637 14.8646 42.8237 16.2268 42.1767 16.8987C41.3079 17.8048 40.0571 18.2363 39.6689 17.7678C39.5272 17.5891 39.5642 17.1391 39.7613 16.6645C40.2543 15.4933 41.579 13.7736 42.4047 13.2373C43.2365 12.6887 43.6986 12.1524 43.6001 11.8442C43.5816 11.7703 43.4337 11.5607 43.2858 11.3819C42.8422 10.8641 42.9901 10.7717 43.902 11.0059ZM34.3822 11.8134C34.4068 12.0476 34.1234 12.3435 33.384 12.849C33.0389 13.0832 32.6446 13.3729 32.5029 13.4962C32.09 13.8475 32.0531 14.242 32.3858 14.6427C32.472 14.7475 32.546 14.8831 32.546 14.9509C32.546 15.6844 29.8903 18.2117 29.1262 18.2117C28.9229 18.2117 28.6272 18.0637 28.5779 17.9343C28.4608 17.6261 28.6272 16.9295 28.9537 16.3686C29.7609 14.9694 31.9791 12.7627 33.5072 11.8319C33.7906 11.6593 33.9262 11.6161 34.1172 11.6285C34.3329 11.647 34.3637 11.6655 34.3822 11.8134ZM63.2312 11.7209C63.225 12.2942 61.1855 14.2667 60.6002 14.2667C60.5139 14.2667 60.4584 14.2297 60.4584 14.1742C60.4584 13.829 61.3396 12.8181 62.2145 12.1524C62.8862 11.647 63.2312 11.499 63.2312 11.7209ZM11.3867 26.6995C11.3621 26.7981 11.2389 27.094 11.1033 27.3652C10.2468 29.1097 7.91155 31.7602 6.53133 32.5615C5.57627 33.1101 4.93545 32.6047 5.40374 31.6739C5.95829 30.552 8.7557 27.994 10.6966 26.829C11.2697 26.4776 11.4422 26.4468 11.3867 26.6995Z"
      fill="#FAE0B5"
    />
    <path
      d="M73.1521 5.30928C72.7269 5.52505 71.7778 6.46212 71.4943 6.94916C71.2601 7.34988 71.1862 7.76293 71.3033 8.04035C71.4635 8.42874 72.1291 8.8418 72.5851 8.8418C73.1521 8.8418 74.1319 8.05268 74.5017 7.29439C74.7913 6.69639 74.8222 6.24019 74.6065 5.79014C74.286 5.14899 73.7992 4.98254 73.1521 5.30928Z"
      fill="#FAE0B5"
    />
    <path
      d="M80.9683 8.8418L80.9683 27.5366"
      stroke="#FAE0B5"
      stroke-width="1.25"
    />
    <path
      d="M95.7119 18.9473L93.9697 13.877L92.1182 18.9473H95.7119ZM93.1572 12.1738H94.915L99.0791 23.6504H97.376L96.2119 20.2129H91.6729L90.4307 23.6504H88.8369L93.1572 12.1738ZM106.789 17.4316C107.518 17.4316 108.094 17.2858 108.516 16.9941C108.943 16.7025 109.156 16.1764 109.156 15.416C109.156 14.5983 108.859 14.041 108.266 13.7441C107.948 13.5879 107.523 13.5098 106.992 13.5098H103.195V17.4316H106.789ZM101.641 12.1738H106.953C107.828 12.1738 108.55 12.3014 109.117 12.5566C110.195 13.0462 110.734 13.9499 110.734 15.2676C110.734 15.9551 110.591 16.5176 110.305 16.9551C110.023 17.3926 109.628 17.7441 109.117 18.0098C109.565 18.1921 109.901 18.4316 110.125 18.7285C110.354 19.0254 110.482 19.5072 110.508 20.1738L110.563 21.7129C110.578 22.1504 110.615 22.4759 110.672 22.6895C110.766 23.054 110.932 23.2884 111.172 23.3926V23.6504H109.266C109.214 23.5514 109.172 23.4238 109.141 23.2676C109.109 23.1113 109.083 22.8092 109.063 22.3613L108.969 20.4473C108.932 19.6973 108.654 19.1947 108.133 18.9395C107.836 18.7988 107.37 18.7285 106.734 18.7285H103.195V23.6504H101.641V12.1738ZM118.812 11.8613C120.265 11.8613 121.392 12.2441 122.194 13.0098C122.996 13.7754 123.442 14.6452 123.53 15.6191H122.015C121.843 14.8796 121.499 14.2936 120.983 13.8613C120.473 13.429 119.754 13.2129 118.827 13.2129C117.697 13.2129 116.783 13.6113 116.085 14.4082C115.392 15.1999 115.046 16.416 115.046 18.0566C115.046 19.4004 115.358 20.4915 115.983 21.3301C116.614 22.1634 117.551 22.5801 118.796 22.5801C119.942 22.5801 120.814 22.14 121.413 21.2598C121.731 20.7962 121.968 20.1868 122.124 19.4316H123.64C123.504 20.64 123.056 21.653 122.296 22.4707C121.385 23.4551 120.155 23.9473 118.608 23.9473C117.275 23.9473 116.155 23.5436 115.249 22.7363C114.056 21.6686 113.46 20.0202 113.46 17.791C113.46 16.0983 113.908 14.7103 114.804 13.627C115.773 12.4499 117.108 11.8613 118.812 11.8613ZM126.537 12.1738H128.108V16.916H134.076V12.1738H135.647V23.6504H134.076V18.2832H128.108V23.6504H126.537V12.1738ZM139.372 12.1738H140.943V23.6504H139.372V12.1738ZM145.34 12.1738L148.637 21.9473L151.895 12.1738H153.637L149.449 23.6504H147.801L143.621 12.1738H145.34ZM156.214 12.1738H164.581V13.5801H157.73V17.0645H164.066V18.3926H157.73V22.2832H164.698V23.6504H156.214V12.1738ZM168.713 19.9473C168.75 20.5983 168.903 21.127 169.174 21.5332C169.69 22.2936 170.599 22.6738 171.901 22.6738C172.484 22.6738 173.015 22.5905 173.494 22.4238C174.421 22.1009 174.885 21.5228 174.885 20.6895C174.885 20.0645 174.69 19.6191 174.299 19.3535C173.903 19.0931 173.283 18.8665 172.44 18.6738L170.885 18.3223C169.869 18.0931 169.151 17.8405 168.729 17.5645C168 17.0853 167.635 16.3691 167.635 15.416C167.635 14.3848 167.992 13.5384 168.705 12.877C169.419 12.2155 170.429 11.8848 171.737 11.8848C172.94 11.8848 173.961 12.1764 174.799 12.7598C175.643 13.3379 176.065 14.265 176.065 15.541H174.604C174.526 14.9264 174.359 14.4551 174.104 14.127C173.63 13.528 172.825 13.2285 171.69 13.2285C170.773 13.2285 170.114 13.4212 169.713 13.8066C169.312 14.1921 169.112 14.64 169.112 15.1504C169.112 15.7129 169.346 16.1243 169.815 16.3848C170.122 16.5514 170.817 16.7598 171.901 17.0098L173.51 17.377C174.286 17.554 174.885 17.7962 175.307 18.1035C176.036 18.64 176.401 19.4186 176.401 20.4395C176.401 21.7103 175.937 22.6191 175.01 23.166C174.088 23.7129 173.015 23.9863 171.791 23.9863C170.364 23.9863 169.247 23.6217 168.44 22.8926C167.632 22.1686 167.237 21.1868 167.252 19.9473H168.713Z"
      fill="#FAE0B5"
    />
  </svg>
)

export const VideoPopup = (props) => {
  const [innerWidth, set] = useState(window.innerWidth)
  const pageState = usePage()
  const time = useRef(0)
  const vid = useRef(null)
  const [duration, setDuration] = useState(0)
  const [secElapsed, setSecElapsed] = useState(0)

  /**
   * Added GA
   */

  const handleResize = () => {
    set(window.innerWidth)
  }

  const handleDuration = (dur) => {
    setDuration(dur)
  }

  const handleProgress = (prog) => {
    if (!duration) return
    const secondsElapsed = prog.played * duration
    if (secondsElapsed !== secElapsed) {
      setSecElapsed(secondsElapsed)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    time.current = new Date().getTime()

    sendEvent('video started', `video`, `${props.title}`)
    // ReactGA.event({
    //   category: `video - ${props.title}`,
    //   action: `opened video`,
    // })

    return () => {
      window.removeEventListener('resize', handleResize)
      sendEvent(
        `closed video, duration: ${(
          (new Date().getTime() - time.current) /
          1000
        ).toFixed(2)} seconds`,
        `video`,
        `${props.title}: ${secElapsed.toFixed(2)} seconds`
      )

      //   ReactGA.event({
      //     category: `video - ${props.title}`,
      //     action: `closed video, duration: ${(
      //       (new Date().getTime() - time.current) /
      //       1000
      //     ).toFixed(2)} seconds`,
      //   })
      // console.log(((new Date().getTime() - time.current)/1000).toFixed(2))
    }
  }, [secElapsed])
  return (
    <>
      <div>
        {/* <div className={css(styles.logo)}>
                        <Logo />
                    </div> */}
        {/* <Logo style={{left:0,top:'2%'}}/> */}
        {/* <video 
                    className={css(styles.Image)} 
                    style={{
                        maxWidth:innerWidth/window.innerHeight>1.3?window.innerHeight*0.94 * 16/9:window.innerHeight*0.94 * 16/9,
                        // height:innerWidth/window.innerHeight>1.3?'92.2%':'',
                        maxHeight:innerWidth/window.innerHeight>1.3?'92.2%':'92.2%'
                        
                    }}
                    height='100%'
                    controls
                    autoPlay 
                >
                            <source src={props.url}/>
                    </video> */}
        <div
          className={css(styles.Image)}
          style={{ top: props.text ? '16.5%' : '14%' }}
        >
          <Logo className={css(styles.logo)} />
          <VimeoPlayer
            height="100%"
            width="100%"
            controls={true}
            url={props.url}
            ref={vid}
            onProgress={handleProgress}
            onDuration={handleDuration}
          />
        </div>
        <div className={css(styles.TextContainer)}>
          <h2 className={css(styles.Heading)}>{props.title}</h2>
          <p className={css(styles.SubText)}>{props.text}</p>
        </div>
      </div>
    </>
  )
}

const styles = StyleSheet.create({
  Image: {
    // posit',
    border: '#FFE7BA 4px solid',
    // marginLeft:'2%',
    // marginRight:'2%',
    height: '75%',
    backgroundColor: 'black',
    width: '71%',
    left: '50%',
    position: 'absolute',
    // marginTop:32,
    // marginTop:'2.32%',
    transform: 'translateX(-50%)',
    // top:'18%',
  },
  TextContainer: {
    zIndex: 100,
    position: 'absolute',
    width: '100%',
    // height:'8%',
    top: '3.5%',
    textAlign: 'center',
  },
  Heading: {
    color: '#FFE7BA',

    bottom: 0,
    fontFamily: 'Bungee Inline',
    fontWeight: 1,
    fontSize: 22.5,
    lineHeight: '2%',
    '@media (max-height: 700px)': {
      lineHeight: -4,
      fontSize: 17,
    },
  },
  SubText: {
    color: '#FFE7BA',
    fontFamily: 'futura',
    margin: 0,
    fontSize: 18,
    fontWeight: 100,
    lineHeight: '21px',
    '@media (max-width: 900px)': {
      fontSize: 14,
      lineHeight: '17px',
    },
  },
  Close: {
    position: 'absolute',
    top: '0.4%',
    right: '0.4%',
    '@media (max-width: 1000px)': {
      transform: 'scale(0.7)',
    },
    '@media (max-width: 600px)': {
      transform: 'scale(0.65)',
      top: 0,
      right: 0,
    },
  },
  logo: {
    width: '15vh',
    height: '10%',
    top: '-0.5%',
    right: '1%',
    // backgroundColor:'red',
    position: 'absolute',
    zIndex: 110000,
  },
})
